import React from 'react';
import NavBar from '../navbar/NavBar';
import style from './header.module.css';
import logo from '../../images/bd.png';
import handleScroll from '../scroll/handleScroll';
import { useNavigate } from 'react-router-dom';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

function Header({ visibleElements, elementsRef, setIsScrolling, isOpenMenu, toggleMenu }) {
  const navigate = useNavigate();
  const handleLinkClick = (e, targetId) => {
    handleScroll(e, targetId, navigate, isOpenMenu, toggleMenu, setIsScrolling);
  };

  return (
    <header className={style['header']}>
      <a href='#home' className={style['header__company']}
        onClick={(e) => handleLinkClick(e, 'home')}
        ref={(el) => (elementsRef.current[0] = el)}>
        <img src={logo} alt='Logo de BrokenDev' className={`lazyload ${style['header__logo']} 
        ${visibleElements.includes(elementsRef.current[0]) ?
            style['header__logo--transition'] : ''}`} />
        <h2 className={`${style['header__title']} 
        ${visibleElements.includes(elementsRef.current[0]) ?
            style['header__title--transition'] : ''}`}>BrokenDev</h2>
      </a>
      <NavBar visibleElements={visibleElements} elementsRef={elementsRef}
        handleLinkClick={handleLinkClick} isOpenMenu={isOpenMenu} toggleMenu={toggleMenu} />
    </header>
  );
}

export default Header;
